import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import {
  handleSignOut,
  redirectSignInWithPreviousRoute,
} from "@/lib/aws-amplify/auth";
import { isSafeInternalPath } from "@/lib/is-safe-internal-path";

const SEARCH_PARAMS_PREVIOUS_ROUTE = "previous";

/**
 * previous は「サインアウト時点の URL」を載せる契約なので、レンダー時でなく呼び出し時に
 * window.location から読む（auth.tsx の非フック版 redirectSignInWithPreviousRoute に委譲）。
 * 返す関数は参照安定（呼び出し側の effect 依存配列に入れても再実行を誘発しない）。
 */
export const useSignOutWithPreviousRoute = () => {
  const signOutWithPreviousRoute = useCallback(() => {
    handleSignOut()
      .then(() => {
        redirectSignInWithPreviousRoute();
      })
      .catch((error) => {
        console.log("error signing out with previous: ", error);
      });
  }, []);

  return {
    redirectSignInWithPreviousRoute,
    signOutWithPreviousRoute,
  };
};

export const usePreviousRoutePath = () => {
  const [searchParams] = useSearchParams();
  const rawPrevRoute = searchParams.get(SEARCH_PARAMS_PREVIOUS_ROUTE);

  // オープンリダイレクト対策: 外部由来の previous は同一オリジンの内部パス以外を弾き、
  // 不正な場合は null（呼び出し側でデフォルト遷移先にフォールバック）にする。
  const prevRoute = isSafeInternalPath(rawPrevRoute) ? rawPrevRoute : null;

  return { prevRoute };
};
